import { render, staticRenderFns } from "./CardPendencies.vue?vue&type=template&id=21c741a0"
import script from "./CardPendencies.vue?vue&type=script&lang=js"
export * from "./CardPendencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports